module.exports = __webpack_public_path__ + "img/f685fe85d816fc917a7ff3ec0574c42.5d1bb758.png";